import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-supplier-details-edit',
  templateUrl: './supplier-details-edit.component.html',
  styleUrl: './supplier-details-edit.component.css'
})
export class SupplierDetailsEditComponent implements ICellRendererAngularComp {
  tempData: any;
    
  constructor() {}
  
  gridApi: GridApi;
  params;
  
  refresh(_params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params): void {
    this.params = params;
  }

  edit($event) {
    const context = this.params.context;
    const node = this.params.node;
    const api = this.params.api;
    const currentlyEditingRow = context.currentlyEditingRow;
    if (currentlyEditingRow && currentlyEditingRow !== node) {
      context.currentlyEditingRow.data.editable = false;
      delete context.tempEditData[context.currentlyEditingRow.id];
    }
    node.data.editable = true;  
    context.currentlyEditingRow = node;
    context.tempEditData[node.id] = { ...this.params.data };
    api.refreshCells({ rowNodes: [node], force: true });

    if (this.params.edit instanceof Function) {
      const params = { //NOSONAR
        event: $event,
        rowData: this.params.node.data,
        api:this.params.gridApi
      }
      this.params.edit(this.params);
    }
  }

  update($event) {
    const context = this.params.context;
    const node = this.params.node;
    const tempData = context.tempEditData[node.id];

    if (this.params.update instanceof Function) {
      const params = {
        event: $event,
        rowData: { ...tempData }, // pass only the tempData for validation
        api: this.params.gridApi
      };

      const success = this.params.update(params);  // Assume returns true if valid
      if (success === true) {
        Object.assign(this.params.data, tempData);
        node.data.editable = false;
        delete context.tempEditData[node.id];
        context.currentlyEditingRow = null;
      }
    }
  }

  cancel($event) {
    const context = this.params.context;
    const node = this.params.node;
    node.data.editable = false;
    delete context.tempEditData[node.id];
    if (context.currentlyEditingRow === this.params.node) {
      context.currentlyEditingRow = null;
    }

    if (this.params.cancel instanceof Function) {
      const params = { //NOSONAR
        event: $event,
        rowData: this.params.node.data,
        api:this.params.gridApi
      }
      this.params.cancel(this.params);
    }
  }
}
